import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const toggleGroupStyle = {
  boxShadow: "0px 4px 6px 0px #c3c3c3",
};

const toggleStyle = {
  height: "25px",
  fontSize: "12px",
  fontWeight: "bold",
  backgroundColor: "white",
  borderRadius: "0px",
  borderWidth: "0px",
  textTransform: "capitalize",
  "&.MuiToggleButton-root.Mui-selected": {
    backgroundColor: "#49B970",
    color: "#F7F7F7",
  },
  "&.MuiToggleButton-root.Mui-disabled": {
    backgroundColor: "#F7F7F7",
    color: "#C2C2C2",
  },
  "&.MuiToggleButton-root:hover": {
    backgroundColor: "#D8E5DE",
    color: "#757575",
  },
  "&.MuiToggleButton-root.Mui-selected:hover": {
    backgroundColor: "#49B970",
    color: "#F7F7F7",
  },
};

const Toggle = (props) => {
  const handleChange = (event, newOption) => {
    if (newOption !== null) {
      props.toggleChange(newOption);
    }
  };

  return (
    <ToggleButtonGroup
      value={props.activeOption}
      exclusive={true}
      onChange={handleChange}
      aria-label="test"
      className="toggle-button-group"
      sx={toggleGroupStyle}
    >
      {props.toggleOptions.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          disabled={option.disabled}
          className="toggle-button"
          sx={toggleStyle}
        >
          {option.value}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default Toggle;
